import type * as Types from '@shared/types/graphqlGenerated.ts';

import * as Operations from './CatalogContextualFiltersV2.query';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CatalogContextualFiltersV2SharedQueryVariables = Types.Exact<{
  searchSessionId: Types.Scalars['String']['input'];
  dosageFormatSort: Array<Types.DosageFormatSort> | Types.DosageFormatSort;
  allergenSort: Array<Types.AllergenSort> | Types.AllergenSort;
  populationSort: Array<Types.PopulationSort> | Types.PopulationSort;
  thirdPartyCertificationSort: Array<Types.ThirdPartyCertificationSort> | Types.ThirdPartyCertificationSort;
}>;


export type CatalogContextualFiltersV2SharedQuery = { viewer?: Types.Maybe<{ contextualFilters: (
      Pick<Types.ContextualFilters, 'fsTested'>
      & { forms?: Types.Maybe<Array<(
        Pick<Types.DosageFormatContextualFilters, 'id' | 'esResultCount'>
        & { dosageFormat: Pick<Types.DosageFormat, 'id' | 'baseFormat' | 'variation'> }
      )>>, brands?: Types.Maybe<Array<(
        Pick<Types.BrandContextualFilters, 'id' | 'esResultCount'>
        & { brand: Pick<Types.Brand, 'id' | 'name' | 'logo'> }
      )>>, allergens?: Types.Maybe<Array<(
        Pick<Types.AllergenContextualFilters, 'id' | 'esResultCount'>
        & { allergen: Pick<Types.Allergen, 'id' | 'name'> }
      )>>, demographics?: Types.Maybe<Array<(
        Pick<Types.PopulationContextualFilters, 'id' | 'esResultCount'>
        & { population: Pick<Types.Population, 'id' | 'name'> }
      )>>, thirdPartyCertifications?: Types.Maybe<Array<(
        Pick<Types.ThirdPartyCertificationContextualFilters, 'id' | 'esResultCount'>
        & { thirdPartyCertification: Pick<Types.ThirdPartyCertification, 'id' | 'name'> }
      )>> }
    ) }> };



/**
 * __useCatalogContextualFiltersV2SharedQuery__
 *
 * To run a query within a React component, call `useCatalogContextualFiltersV2SharedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogContextualFiltersV2SharedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogContextualFiltersV2SharedQuery({
 *   variables: {
 *      searchSessionId: // value for 'searchSessionId'
 *      dosageFormatSort: // value for 'dosageFormatSort'
 *      allergenSort: // value for 'allergenSort'
 *      populationSort: // value for 'populationSort'
 *      thirdPartyCertificationSort: // value for 'thirdPartyCertificationSort'
 *   },
 * });
 */
export function useCatalogContextualFiltersV2SharedQuery(baseOptions: Apollo.QueryHookOptions<CatalogContextualFiltersV2SharedQuery, CatalogContextualFiltersV2SharedQueryVariables> & ({ variables: CatalogContextualFiltersV2SharedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CatalogContextualFiltersV2SharedQuery, CatalogContextualFiltersV2SharedQueryVariables>(Operations.CatalogContextualFiltersV2_Shared_Query, options);
      }
export function useCatalogContextualFiltersV2SharedQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CatalogContextualFiltersV2SharedQuery, CatalogContextualFiltersV2SharedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CatalogContextualFiltersV2SharedQuery, CatalogContextualFiltersV2SharedQueryVariables>(Operations.CatalogContextualFiltersV2_Shared_Query, options);
        }
export function useCatalogContextualFiltersV2SharedQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CatalogContextualFiltersV2SharedQuery, CatalogContextualFiltersV2SharedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CatalogContextualFiltersV2SharedQuery, CatalogContextualFiltersV2SharedQueryVariables>(Operations.CatalogContextualFiltersV2_Shared_Query, options);
        }
export type CatalogContextualFiltersV2SharedQueryHookResult = ReturnType<typeof useCatalogContextualFiltersV2SharedQuery>;
export type CatalogContextualFiltersV2SharedQueryLazyQueryHookResult = ReturnType<typeof useCatalogContextualFiltersV2SharedQueryLazyQuery>;
export type CatalogContextualFiltersV2SharedQuerySuspenseQueryHookResult = ReturnType<typeof useCatalogContextualFiltersV2SharedQuerySuspenseQuery>;